import { render, staticRenderFns } from "./AddOffers.vue?vue&type=template&id=8315f772"
import script from "./AddOffers.vue?vue&type=script&lang=js"
export * from "./AddOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports